import { AccessRequestClientModel } from '@apono/client-app-sdk';
import { Tooltip, Typography } from '@mui/material';
import { DateTime, Duration } from '@common/utils/datetime';

export default function RevocationTimeCell({ revocation_time }: Pick<AccessRequestClientModel, 'revocation_time'>) {
  const duration = revocation_time ? Duration.fromSeconds(Number(revocation_time) * 1000 - Date.now()) : null;

  if (!revocation_time || !duration || duration.toSeconds < 0) {
    return null;
  }

  return (
    <Tooltip title={'Expires at: ' + DateTime.fromUnix(Number(revocation_time)).readable} arrow placement="top">
      <Typography variant="body2" color="success.main" component="span">
        <Typography variant="tooltip" component="span">
          Time left:
        </Typography>{' '}
        <strong>{duration.readable}</strong>
      </Typography>
    </Tooltip>
  );
}
